import React, { useEffect } from 'react';
import { useMediaQuery } from 'react-responsive';
import prefooterImg from '../../assets/prefooter.png';
import './prefooter.scss';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/all';

export default function PreFooter() {
    const isMediumScreen = useMediaQuery({ query: '(max-width: 850px)' });
    useEffect(() => {
        gsap.registerPlugin(ScrollTrigger);

        let tl = gsap.timeline({
            scrollTrigger: {
                trigger: '.prefooter',
                start: "15% 80%",
                // markers: true,
                end: "bottom 20%",
                toggleActions: "restart none none reset",
                scrub: true,
            }
        });

        tl.to(".prefooter--1", {
            duration: 1,
            y: 0,
            height: "fit-content",// Or an appropriate maximum height
            opacity: 1,
            clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%)", // Animate to full view
            ease: "power4.inOut",
            stagger: {
                amount: 0.3
            }
        }).to(".prefooter--2", {
            duration: 1,
            ease: "power1.out",
            x: 0,
            opacity: 1,
            stagger: {
                amount: 0.3
            }
        }, "-=0.8");
    }, []);

    return (

        <div className='prefooter' style={{
            width: "100%",
            height: "100%",
            backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${prefooterImg})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '80px'
        }}>
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                gap: '70px'
            }}>
                <p className='prefooter--1' style={{ fontSize: isMediumScreen ? '65px' : '120px', fontWeight: 500, lineHeight: isMediumScreen ? '70px' : '130px', textAlign: 'center' }}>Let's Create Some Magic Together.</p>
                <p className='prefooter--2' style={{ fontSize: isMediumScreen ? '15px' : '20px', fontWeight: 400, lineHeight: isMediumScreen ? '22px' : '30px', width: isMediumScreen ? '80%' : '40%', textAlign: 'center' }}>We will help you bring your ideas to life and create memorable events that would last a lifetime.</p>
            </div>
            <button style={{ cursor: 'pointer', borderRadius: '100px', padding: isMediumScreen ? '14px 16px' : '18px 24px', fontSize: isMediumScreen ? '15px' : '18px', fontWeight: 400, lineHeight: isMediumScreen ? '17px' : '21px', color: "#916859", background: '#FBF4E5' }}><a href='/contact'>Contact Us Now</a></button>

        </div>
    )
}